<template>
  <svg :viewBox="`0 0 ${24} ${24}`">
    <path d="m18.37241,20.64828q0,-0.36983 -0.27026,-0.64009t-0.64009,-0.27026t-0.64009,0.27026t-0.27026,0.64009t0.27026,0.64009t0.64009,0.27026t0.64009,-0.27026t0.27026,-0.64009zm3.64138,0q0,-0.36983 -0.27026,-0.64009t-0.64009,-0.27026t-0.64009,0.27026t-0.27026,0.64009t0.27026,0.64009t0.64009,0.27026t0.64009,-0.27026t0.27026,-0.64009zm1.82069,-3.18621l0,4.55172q0,0.56897 -0.39828,0.96724t-0.96724,0.39828l-20.93793,0q-0.56897,0 -0.96724,-0.39828t-0.39828,-0.96724l0,-4.55172q0,-0.56897 0.39828,-0.96724t0.96724,-0.39828l6.07371,0q0.29871,0.79655 1.0028,1.30862t1.57177,0.51207l3.64138,0q0.86767,0 1.57177,-0.51207t1.0028,-1.30862l6.07371,0q0.56897,0 0.96724,0.39828t0.39828,0.96724zm-4.62285,-9.21724q-0.24181,0.56897 -0.83922,0.56897l-3.64138,0l0,6.37241q0,0.36983 -0.27026,0.64009t-0.64009,0.27026l-3.64138,0q-0.36983,0 -0.64009,-0.27026t-0.27026,-0.64009l0,-6.37241l-3.64138,0q-0.59741,0 -0.83922,-0.56897q-0.24181,-0.55474 0.19914,-0.98147l6.37241,-6.37241q0.25603,-0.27026 0.64009,-0.27026t0.64009,0.27026l6.37241,6.37241q0.44095,0.42672 0.19914,0.98147z"/>
  </svg>
</template>

<script>
export default {
  name: 'Upload',
  props: {
    width: {
      default: 24,
      type: Number
    },
    height: {
      default: 24,
      type: Number
    },   
  },
}
</script>


<style scoped lang="scss">
svg {
  // position: relative;
  // top: -0.5px;
  // right: -0.5px;
  transform: translate(0.25px, -0.25px);
  stroke: #2c3e50;
  stroke-width: 1;
}
</style>
